/*
 * Copyright (c) 2025-Present, Your Company, Inc. and/or its affiliates. All rights reserved.
 * The Auth0 software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License").
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
console.log("window.location.origin", window.location.origin);
const domain = process.env.REACT_APP_AUTH0_DOMAIN;
const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
const audience = process.env.REACT_APP_AUTH0_AUDIENCE;

// Generate a random string for state
function makeid(length) {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default {
  auth0: {
    domain: domain,
    clientId: clientId,
    audience: audience,
    redirectUri: window.location.origin,
    scope: "openid profile email offline_access",
    responseType: 'code',
    grantType: 'authorization_code',
    tokenRefreshMode: 'in-memory'
  },
  resourceServer: {
    messagesUrl: "http://localhost:3000/api/messages",
  },
  app: {
    basename: "",
  },
};
